import React from 'react';
import ReactSelect from 'react-select';
import TooltipComponent from '../../../utils/TooltipComponent';

const Select = ({
	className,
	wrapperClassname = '',
	tooltip = false,
	...props
}) => {
	return (
		<div
			className={`wp-checkout-select-wrapper ${tooltip ? 'has-tooltip' : ''} ${props?.error ? 'has-errors' : ''} ${wrapperClassname}`}
		>
			<ReactSelect
				classNames={{
					control: () => 'wp-checkout-react-select-control',
				}}
				className={`wp-checkout-font-base wp-checkout-react-select ${className}`}
				classNamePrefix="wpd-new-checkout-select"
				{...props}
			/>

			{tooltip && props?.error && (
				<TooltipComponent tooltipText={props.error}>
					<span
						aria-describedby="button-tooltip"
						className="wp-checkout-react-select-error"
					>
						<i
							className="wpd-icon wpd-information-solid"
							style={{ color: '#FF0000' }}
						></i>
					</span>
				</TooltipComponent>
			)}

			{!tooltip && props?.error && (
				<p className="wp-checkout-form-input-error wp-checkout-font-sm">
					{props?.error}
				</p>
			)}
		</div>
	);
};

export default Select;
